import styled from '@emotion/styled';

import CustomerCenter from './CustomerCenter';
import SiteMap from './SiteMap';
import { useDetermineMobile } from '@myrealtrip/device-detect';

export default function FooterTopBox() {
  const isMobile = useDetermineMobile();
  const Container = isMobile ? MobileContainer : DesktopContainer;

  return (
    <Container>
      <CustomerCenter />
      <SiteMap />
    </Container>
  );
}

const CommonContainer = styled.div`
  display: flex;
  padding-bottom: 32px;
`;

const MobileContainer = styled(CommonContainer)`
  flex-direction: column;
`;

const DesktopContainer = CommonContainer;
